/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-26 11:05:00
 * @LastEditTime: 2020-09-27 09:38:18
 * @Description: 运输单store
 */
import {
    getDelivery,
    createDelivery,
    updateDelivery,
    getDeliveryHistory,
    createDeliveryBySalesOrder
} from '@/api/delivery'

const state = {
    delivery: {}
}

const getters = {
    getDeliveryById: (state) => (id) => {
        return state.delivery.find(x => x._id === id)
    }
}

const actions = {
    async getDeliveryAction({
        commit
    }, payload) {
        try {
            const delivery = await getDelivery(payload)
            commit('SETDELIVERY', delivery.data)
            return delivery.data
        } catch (error) {
            throw error.message
        }
    },
    async createDeliveryAction({
        commit
    }, payload) {
        try {
            const newDelivery = await createDelivery(payload)
            return newDelivery.data
        } catch (error) {
            throw error.message
        }
    },
    async updateDeliveryAction({
        commit
    }, payload) {
        try {
            const newDelivery = await updateDelivery(payload.id, payload.data)
            commit('salesOrder/UPDATEFACTORYSALESORDERDELIVERY', newDelivery.data, {
                root: true
            })
            return newDelivery.data
        } catch (error) {
            throw error.message
        }
    },
    async getDeliveryHistoryAction({
        commit
    }, payload) {
        try {
            const deliveryList = await getDeliveryHistory(payload);
            return deliveryList.data
        } catch (error) {
            throw error.message
        }
    },
    async createDeliveryBySalesOrderAction({
        commit
    }, id) {
        try {
            const delivery = await createDeliveryBySalesOrder(id)
            // commit('SET_DELIVERY', delivery);
            return delivery.data
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
    SETDELIVERY(state, payload) {
        state.delivery = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}